export class CenterControl {
  onAdd(map) {
    this._map = map;

    this._btn = document.createElement('button');
    this._btn.className = 'mapboxgl-ctrl-icon mapboxgl-ctrl-center';
    this._btn.type = 'button';
    this._btn['aria-label'] = 'Centrer la position';
    this._btn.onclick = () => {
      const plane = window.tb.world.children.find((item) => item.name === 'threeboxObject');
      if (plane !== undefined) {
        const EarthCircumference = 40.075 * 1000000;
        const zoom = Math.log(EarthCircumference / plane.coordinates[2], 2) + 1;
        map.panTo(plane.coordinates, { duration: 500, zoom });
      }
    };
    this._container = document.createElement('div');
    this._container.className = 'mapboxgl-ctrl-group mapboxgl-ctrl';
    this._container.appendChild(this._btn);
    return this._container;
  }

  updateStyles() {
    if (
      window.location.pathname === '/vol/share' ||
      window.location.pathname === '/flight/review'
    ) {
      this._container.hidden = false;
    } else {
      this._container.hidden = true;
    }
  }

  onRemove() {
    this._container.parentNode.removeChild(this._container);
    this._map = undefined;
  }
}
